import classNames from "classnames";
import React from "react";
import { WidgetInputProps, WidgetInputRadioButtons } from "../../types";
import styles from "../styles.css";
import { WidgetInputLabel } from "@fidget/common/components/chat/widgetInputLabel/widgetInputLabel";
import { InputButton } from "./inputButton";

interface Props extends WidgetInputProps {
  input: WidgetInputRadioButtons;
}
export const RadioButtonsInput = ({ input, isSubmitted, onChange, userAnswers }: Props) => {
  return (
    <div>
      <WidgetInputLabel text={input.displayName} />
      <div
        className={classNames(styles.options, {
          [styles.column]: input.style === "vertically_aligned"
        })}
      >
        {input.buttons.map((b) => (
          <InputButton
            disabled={isSubmitted}
            key={b.value}
            onClick={() => onChange({ inputName: input.name, value: b.value })}
            primary={userAnswers[input.name]?.value === b.value}
          >
            {b.displayName}
          </InputButton>
        ))}
      </div>
    </div>
  );
};
